import { FileCheck2 } from 'lucide-react';

/** Premium-UI pill button — "check" (validate rows + toast totals) then CSV-export.
 *  Stays visible-but-greyed when disabled so users always see the option. */
export const CheckExportBtn = ({ onClick, testId, title = 'Validate the rows then download as CSV', disabled = false }) => (
  <button
    type="button"
    onClick={(e) => { e.stopPropagation(); if (!disabled) onClick(); }}
    disabled={disabled}
    title={disabled ? 'Nothing to export yet' : title}
    data-testid={testId}
    className={`flex items-center gap-1 px-2 py-0.5 text-[10px] font-semibold rounded-md border transition-colors shrink-0 ${
      disabled
        ? 'text-muted-foreground/60 bg-muted/40 border-border cursor-not-allowed'
        : 'text-info bg-info/10 border-info/30 hover:bg-info/20'
    }`}
  >
    <FileCheck2 size={11} /> Check &amp; Export
  </button>
);

export default CheckExportBtn;
